export const envTest = false; //change to true to use baseUrlTest
const baseUrlTest = "https://localhost:44365";
const baseUrl = "https://api.portalsoftcase.com.br/apptrevo";
export const urlApi = envTest ? baseUrlTest :  baseUrl

// Add proxy configuration for development environments
export const getApiUrl = (endpoint) => {
  return `${urlApi}${endpoint}`;
};

export const timeoutBig = 30000 //30s
export const timeoutStandart = 10000 //10s
export const timeoutSmall = 5000 //5s

export const timeoutIntegration = 10000 //10s

